export enum VituToastTone {
    Neutral = 1,
    Positive = 2,
    Negative = 3,
}
